<!-- here we can manage options style and new cases -->
<ng-template #optionTemplate let-option>
  <div class="option-content">
    @if (option) {
      <i [class.icon-check]="option.selected"></i>
      {{ option.label }}
    } @else {
      obj.label missing
    }
  </div>
</ng-template>

<ng-template #noResult>
  <div class="no-result-container"><span>options not found</span></div>
</ng-template>

<mat-form-field appearance="outline" style="width: 100%">
  <mat-select
    #select
    multiple
    [disabled]="!selectList().length || disabled()"
    [ngModel]="selectedValues"
    style="position: relative"
    [placeholder]="label()"
    (opened)="searchInput.focus()"
  >
    <div>
      <div class="search-container">
        <button
          class="multiselect-button"
          [disabled]="!selectedValues.length"
          title="Reset"
          (click)="onClickResetSelection()"
        >
          <i class="icon-trash"></i>
        </button>
        <input class="search-input" #searchInput [(ngModel)]="inputSearchValue" placeholder="Search..." />
        @if (inputSearchValue()) {
          <button class="multiselect-button" title="Clear" (click)="onClickClearSearchInput()">
            <i class="icon-x-circle2"></i>
          </button>
        }
      </div>
      @if (mode() === 'group') {
        @for (item of multiSelectItemsGroup(); track item._id) {
          @if (item.visible) {
            <mat-optgroup [label]="item.label">
              @for (option of item.options; track option._id) {
                <mat-option
                  [class.hidden]="!filterOption(option, inputSearchValue())"
                  [value]="option"
                  (onSelectionChange)="onSelectionChange($event, option)"
                >
                  <ng-container
                    [ngTemplateOutlet]="optionTemplate"
                    [ngTemplateOutletContext]="{ $implicit: option }"
                  ></ng-container>
                </mat-option>
              }
            </mat-optgroup>
          }
        }
      } @else if (mode() === 'single') {
        @for (option of multiSelectItemsT(); track option._id) {
          <mat-option
            [class.hidden]="!filterOption(option, inputSearchValue())"
            [value]="option"
            (onSelectionChange)="onSelectionChange($event, option)"
          >
            <ng-container
              [ngTemplateOutlet]="optionTemplate"
              [ngTemplateOutletContext]="{ $implicit: option }"
            ></ng-container>
          </mat-option>
        }
      }
      @if (!anyVisibleOptions()) {
        <ng-container [ngTemplateOutlet]="noResult"></ng-container>
      }
    </div>
  </mat-select>
</mat-form-field>
